function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.5.5@@babel/runtime/helpers/interopRequireDefault.js
// module id = 745
// module chunks = 0